<template>
  <div v-if="chartData[0] && chartData[0].data?.length > 0">
    <apexchart
      :options="chartOptions"
      :series="chartData"
    />
  </div>
  <div v-else id="no-records">
        <span><i class="fas fa-circle-xmark"></i>   Não há registros para gerar gráfico</span>
  </div>
</template>

<script>
export default {
  props: ['bankData', 'bankTotal', 'period'],
  data(){
    return {
      chartData: [],
      bankList: [],
      bankArray: [],
      sortedBank: [],
      colorArray: [],
        loading: false
    }
  },
  mounted(){
  },
  watch: {
    async bankData() {
      this.chartData = [];
      this.loading = true;
      this.bankList = [];
      const bankArray = Object.entries(this.bankData);
      bankArray.forEach(month => {
        Object.entries(month[1]).forEach(bank => {
          const record = this.bankList.find(obj => obj == bank[0])
          if(!record){
            this.bankList.push(bank[0]);
          }
        })
      })
      if(this.bankList.length > 0){
        await this.generateChart();
        await this.fillerGenerator();
      }
      this.loading = false;
    }
  },
  methods: {
    async generateChart(){
      this.chartData = [];
      this.sortedBank = [];
      this.bankArray = []; //array de objetos - cada banco terá as propriedades com os nomes dos meses
      let months = [];

      this.bankList.forEach(bank => {
        Object.entries(this.bankData).forEach(el => {
          this.bankArray[bank] = {...months};
        })
      })

      Object.entries(this.bankData).forEach(el => {
        Object.entries(el[1]).forEach(bank => {
          this.bankArray[bank[0]][el[0]] = bank[1];
        })
      })

      this.sortedBank = Object.entries(this.bankArray).sort((a, b) => {
        let somaA = 0;
        let somaB = 0;
        Object.values(a[1]).forEach(el => somaA += el);
        Object.values(b[1]).forEach(el => somaB += el);
        if(somaA < somaB) return 1;
        if(somaB < somaA) return -1;
        if(somaA == somaB) return;
      })

      this.sortedBank.forEach(bank => {
        let values = [];
        Object.values(bank[1]).forEach((el, index) => {
          values.push(el)
        })
        this.chartData.push({data: values, name: bank[0]});
      })
    },
    async nameFormatter(){
      this.chartData.forEach(el => {
        if(this.period == 'month' || this.period == 'day'){
          el.name = el.name.replaceAll('-', '/');
        } else if(this.period == 'week'){
          el.name = 'S' + el.name.replace('-', '/');
        } else if(this.period == 'hour'){
          if(el.name == '23'){
            el.name = `${parseInt(el.name)}h - 0h`;
          } else {
            el.name = `${parseInt(el.name)}h - ${parseInt(el.name) + 1}h`;
          }
        }
      })
    },
    colorGenerator() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }

      return color;
    },
    async fillerGenerator(){
      let tempArray = [];
      if(this.chartData && this.chartData.length > 0 && this.chartData.length > this.colorArray.length){
        this.colorArray = [];
        for (var i = 0; i < this.chartData.length; i++) {
          tempArray.push(this.colorGenerator());
        }
        this.colorArray = tempArray;
      }
    }
  },
  computed: {
    chartOptions() {
      return {
        title: {
          text: 'Atendimentos por Instituição Financeira',
        },
        chart: {
          type: 'line',
        },
        colors: this.colorArray,
        dataLabels: {
          enabled: true
        },
        stroke: {
          curve: 'smooth'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: this.chartCategories,
        }
      };
    },
    chartCategories() {
      let categories = [];
      Object.keys(this.bankData).forEach(el => {
        if(this.period == 'month' || this.period == 'day'){
          el = el.replaceAll('-', '/');
        } else if(this.period == 'week'){
          el = 'S' + el.replace('-', '/');
        } else if(this.period == 'hour'){
          if(el == '23'){
            el = `${parseInt(el)}h - 0h`;
          } else {
            el = `${parseInt(el)}h - ${parseInt(el) + 1}h`;
          }
        }
        categories.push(el);
      })
      return categories;
    },
  },
}
</script>

<style scoped>
  #chart-area{
    background-color: white;
  }
  #no-records {
    height: 90%;
    display: flex;
    justify-content: center;
  }

  #no-records span{
      align-self: center;
      font-size: x-large;
      font-weight: bold;
      color: #1c869a;
  }

  #no-records span i{
      color: red;
  }

  #loading {
    height: 90%;
    display: flex;
    justify-content: center;
  }

  #loading span{
    align-self: center;
    font-size: x-large;
    font-weight: bold;
    color: #1c869a;
  }
</style>